export default { 
  name: 'pages', 
  path: '/pages', 
  children: [ 
    { name: 'membership', path: '/membership' },
    { name: 'terms', path: '/terms-and-conditions' },
    { name: 'privacy', path: '/privacy' },
    { name: 'about', path: '/about' }
  ]
}
